/**
 * ProviderSignupPage duck - minimal Redux duck for placeholder page
 * This will be expanded when the actual provider signup flow is implemented
 */

// ================ Action types ================ //

export const PROVIDER_SIGNUP_PAGE_LOAD_DATA = 'app/ProviderSignupPage/LOAD_DATA';

// ================ Reducer ================ //

const initialState = {
  // Placeholder state - will be expanded for actual signup flow
  isLoading: false,
  error: null,
};

export default function providerSignupPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case PROVIDER_SIGNUP_PAGE_LOAD_DATA:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const providerSignupPageLoadData = () => ({
  type: PROVIDER_SIGNUP_PAGE_LOAD_DATA,
});

// ================ Thunks ================ //

// Minimal loadData function that returns null for now
// This will be expanded when actual provider signup flow is implemented
export const loadData = (params, search) => {
  return (dispatch, getState, sdk) => {
    // For now, just dispatch a simple action and return null
    dispatch(providerSignupPageLoadData());
    return Promise.resolve(null);
  };
};